import { Component, ErrorInfo, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getErrorDetails } from "@fyrstain/hl7-front-library";

type BoundaryProps = {
  children: ReactNode;
  resetKey: string;
};

type BoundaryState = {
  error?: unknown;
};

class ErrorBoundary extends Component<BoundaryProps, BoundaryState> {
  state: BoundaryState = {};

  static getDerivedStateFromError(error: unknown): BoundaryState {
    return { error };
  }

  componentDidCatch(_error: unknown, _errorInfo: ErrorInfo): void {
    // The Error page intentionally receives a sanitized error only.
  }

  componentDidUpdate(previousProps: BoundaryProps): void {
    if (this.state.error && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ error: undefined });
    }
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <Navigate
          replace
          state={{ error: getErrorDetails(this.state.error) }}
          to="/Error"
        />
      );
    }

    return this.props.children;
  }
}

const AppErrorBoundary = ({ children }: { children: ReactNode }) => {
  const location = useLocation();

  return <ErrorBoundary resetKey={location.key}>{children}</ErrorBoundary>;
};

export default AppErrorBoundary;
